import { Company } from './Company';
import { Pagination } from './Pagination';
import type { Landing } from './Permissions';

export interface UserCredentials {
  email: string;
  password: string;
}

export interface Register {
  company: {
    name: string;
    address: string;
    province: string;
    city: string;
    phone: string;
    email: string;
    logo: string | null;
  };
  user: {
    name: string;
    email: string;
    password: string;
  };
}

export interface User {
  _id: string;
  name: string;
  email: string;
  active: boolean;
  password: string;
  role: Roles;
  company: Company;
  registrationStatus?: RegistrationStatus;
  emailVerifiedAt?: string;
  /** Platform (GarageDigital) administrator; set by the API from env. */
  isPlatformAdmin?: boolean;
  /** Roles and permissions v2. Absent on legacy sessions. */
  roles?: string[];
  isOwner?: boolean;
  permissions?: string[];
  permissionsHash?: string;
  landing?: Landing;
}

export enum RegistrationStatus {
  PENDING_EMAIL_VERIFICATION = 'pending_email_verification',
  INVITATION_CANCELLED = 'invitation_cancelled',
  ACTIVE = 'active',
}

export interface UserInvitationResult {
  user: User;
  emailDeliveryStatus: 'sent' | 'failed';
  warnings?: { code: string; activeUsers?: number; maxUsers?: number }[];
}

export interface UserInvitationPayload {
  name: string;
  email: string;
  password: string;
  roles: string[];
  grants: string[];
  revokes: string[];
}

export interface UsersPaginated extends Pagination<User> {}

export enum Roles {
  ADMIN = 'admin',
  USER = 'user',
}

export interface LoginData {
  user: User;
  token: string;
}

export interface GoogleIdentity {
  idToken: string;
  email: string;
  displayName: string;
  photoUrl: string | null;
}

export interface GoogleRegister {
  company: Register['company'];
  user: Omit<Register['user'], 'password'>;
}
